import * as LJS from '../lib/littlejs.esm';
import { loadData } from './utils/storage';
class Globals {
}
Globals.LIGHT = 'light';
Globals.DARK = 'dark';
Globals.WHITE = LJS.hsl(0, 1, 1);
Globals.BLACK = LJS.hsl(0, 0, 0);
Globals.PADDING_LEFT = 4;
Globals.PADDING_RIGHT = 4;
Globals.WELL_WIDTH = 40;
Globals.START_DESCENT_SPEED = 0.04;
Globals.MAX_DESCENT_SPEED = 0.12;
Globals.descentSpeed = 0.02;
Globals.entitiesData = [];
Globals.gameState = 'menu';
Globals.world = 'dark';
Globals.depth = 0;
Globals.lastGenerated = 0;
Globals.generationDepth = 0;
Globals.chunkSize = 60;
Globals.lastHeartDepth = 0;
Globals.score = 0;
Globals.bestScore = parseInt(loadData("bestScore") || 0);
Globals.epilepsySafe = loadData("epilepsy_safe") || false;
export default Globals;
